// extracted by mini-css-extract-plugin
export default {"navigation":"Header_navigation__vwuph","navigationBar":"Header_navigationBar__1NeQH","loginBtn":"Header_loginBtn__IYtpM"};